module.exports = __webpack_public_path__ + "img/credit-dial-selected.ed8c1f31.svg";